/**
 * Obtiene el role del usuario desde el JWT en localStorage.
 * Compatible con navegador (sin Buffer de Node).
 */
const getCurrentRole = () => {
  const token = localStorage.getItem('token');
  if (!token) return 0;
  try {
    const parts = token.split('.');
    const payload = parts[1];
    if (!payload) return 0;
    const base64Url = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json =
      typeof atob !== 'undefined'
        ? atob(base64Url)
        : typeof Buffer !== 'undefined'
          ? Buffer.from(base64Url, 'base64').toString('utf-8')
          : '';
    if (!json) return 0;
    const decoded = JSON.parse(json);
    return decoded.role != null ? decoded.role : 0;
  } catch (_) {
    return 0;
  }
};

export default getCurrentRole;



// WEBPACK FOOTER //
// ./src/rbac/getCurrentRole.js